
import { CommonModule } from '@angular/common';
import { Component, effect, HostBinding, Input } from '@angular/core';
import { ControlService } from 'src/app/pages/learner/call/library/control.service';
import { PlayerService } from 'src/app/pages/learner/call/library/player.service';
import { VisualGuideComponent } from '../visual-aid-call-navigation/visual-guide.component';
import { CallStoreService } from '../../library/call-store/call-store.service';
import { NativeCallService } from 'src/app/services/native-call.service';
@Component({
  imports: [
    CommonModule,
    VisualGuideComponent,
  ],
  standalone: true,
  selector: 'app-visual-aid-call-main',
  templateUrl: './visual-aid-call-main.component.html',
  styleUrls: ['./visual-aid-call-main.component.scss'],
})
export class VisualAidCallMainComponent {
  @Input() controlService: ControlService | undefined;
  @Input() playerService: PlayerService | undefined;
  @Input() isLoading = false;
  animation = false;

  constructor(public callStore: CallStoreService, private nativeCallService: NativeCallService) {
    effect(() => {
      const visualAidOpen = this.callStore.getIsVisualAidOpen();
      if (visualAidOpen) {
        this.animation = true;
        setTimeout(() => {
          this.animation = false;
        }, 800);
      }
    });
  }

  @HostBinding('class')
  protected get cssClass() {
    return {
      isLoading: !!this.isLoading,
      'native-ios': this.nativeCallService.isNativeIos,
    };
  }

  
}
